<template>
    <div 
        class="checkbox-toggle btn-sm" 
        role="checkbox" 
        @keydown="toggle" 
        @click.stop="toggle" 
        tabindex="0" 
        :aria-checked="toggled"
    >
        <div 
            class="checkbox-slide" 
            :class="classes"
        >
            <div 
                class="checkbox-switch" 
                :class="classes"
            ></div>
        </div>
        <div
            v-show="showLabels"
            class="checkbox-label"
            v-html="label"
        ></div>
   </div>
</template>

<script>
export default {
    name: "vue-checkbox-toggle",
    computed: {
        classes: function() {
            return {
                checked: this.toggled,
                unchecked: !this.toggled,
                disabled: this.disabled
            };
        },

        label: function() {
            return this.toggled && this.showLabels
                ? this.labelChecked
                : this.labelUnchecked;
        }
    },

    data() {
        return {
            toggled: this.value
        };
    },

    methods: {
        toggle: function(e) {
            if (this.disabled || e.keyCode === 9) { // not if disabled or tab is pressed
                e.stopPropagation();
                return;
            }

            this.toggled = ! this.toggled;

            this.$emit("input", this.toggled);
            this.$emit("clicked");
            this.$emit('focus');
        }
    },

    props: {
        disabled: {
            type: Boolean,
            default: false
        },

        value: {
            type: Boolean,
            default: false
        },

        showLabels: {
            type: Boolean,
            default: false
        },

        labelChecked: {
            type: String,
            default: ""
        },

        labelUnchecked: {
            type: String,
            default: ""
        }
    }
}
</script>

<style lang="scss">
.checkbox-toggle {
    display: inline-block;
    margin: 0;
    height: 2em;
    position: relative;
    &:focus{
        border: none;
        outline: none;
    }
}

.checkbox-slide {
  width: 4em;
  padding: 0;
  margin: 0;
  border-radius: 0.25em;
  cursor: pointer;
  display: inline-block;
}

.checkbox-switch {
  padding: 0;
  margin: 0;
  width: 2em;
  height: 2em;
  border-radius: 0.25em;
  background: #384a5d;
  cursor: pointer;
}

.checkbox-label {
  margin-left: 0.5em;
  display: inline-block;
  position: absolute;
  top: 0;
  height: 2em;
  line-height: 2em;
}

.checkbox-switch.checked {
  transform: translateX(2em);
  transition: all 350ms;
}

.checkbox-switch.unchecked {
  transition: all 350ms;
}

.checkbox-slide.checked {
  transition: all 350ms;
  background: #67af7f;
  display: inline-block;
}

.checkbox-slide.unchecked {
  transition: all 350ms;
  background: lightgray;
}

.checkbox-switch.disabled {
  cursor: not-allowed;
  background: #8da3ba;
}

.checkbox-slide.disabled {
  cursor: not-allowd;
  background: #e0e0e0;
}

</style>

